import clsx from 'clsx'
import map from 'lodash/map'
import React, { FC, ReactNode } from 'react'

import { Button } from '@Components/Button'
import { CheckoutFlowDeliveryTypes } from '@Domains/CheckoutV2/Features/CheckoutSteps/Steps/CheckoutShippingStep/CheckoutShippingStep'
import { useSplitTest } from '@Globals/SplitTests/Hooks'
import { useTranslation } from '@Globals/Translations'

import styles from './DeliveryTabs.module.scss'

export interface DeliveryTab{
  icon: ReactNode
  id: CheckoutFlowDeliveryTypes
  title: string
}
export interface DeliveryTabsProps {
  onSelect: (tab: CheckoutFlowDeliveryTypes) => void
  options: DeliveryTab[]
  selected?: CheckoutFlowDeliveryTypes | null
}

export const DeliveryTabs: FC<DeliveryTabsProps> = ({ onSelect, options, selected }) => {
  const cofDesignV1 = useSplitTest('cof_design_v1', 'b')
  const { t } = useTranslation()

  if (cofDesignV1) {
    return (
      <div className={styles.deliveryTabsV2}>
        {map(options, option => (
          <button
            key={`deliveryTab${option.id}`}
            className={clsx(styles.tabOption, selected === option.id && styles.selected)}
            onClick={() => onSelect(option.id)}
            type="button"
          >
            <span />
            {option.icon}
            {t(option.title)}
          </button>
        ))}
      </div>
    )
  }

  return (
    <div className={styles.deliveryTabs}>
      {map(options, option => (
        <Button
          key={`deliveryTab${option.id}`}
          className={clsx(styles.tabOption, selected === option.id && styles.selected)}
          color={selected === option.id ? 'dark' : 'grey'}
          onClick={() => onSelect(option.id)}
          type="button"
        >
          {option.icon}
          {t(option.title)}
        </Button>
      ))}
    </div>
  )
}

